import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link } from 'gatsby';
import { Typography } from '@mui/material';
import { Link as LinkIcon, PictureAsPdf } from '@mui/icons-material';

const CardInfoContainer = styled.div`
  margin-top: 2rem;

  @media only screen and (min-width: 768px) {
    margin-left: 2rem;
    margin-top: 0;
  }

  h1 {
    margin-top: 0;
  }

  section {
    margin-top: 1em;
  }

  .card-tabs [role='tablist'] {
    border-bottom: 2px solid lightgray;
  }
`;

const CardSendingOptions = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 0;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }

  li {
    display: flex;
    align-items: center;
    margin: 0 0 1rem 0;

    @media only screen and (min-width: 768px) {
      margin: 0 2rem 0 0;
    }

    svg {
      margin-right: 0.5rem;
    }
  }
`;

interface CardInfoParams {
  title: string;
  author: string;
  description: string;
}

const AddToCart = (
  <Link to="configure" className="no-link-decoration">
    <Button variant="contained" color="primary" size="large" sx={{ width: { xs: '100%', md: 'auto'}}}>
      Podaruj kartkę
    </Button>
  </Link>
);

const CardInfo = ({ title, author, description }: CardInfoParams) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  // TODO: find a React HTML parser to avoid using dangerouslySetInnerHTML
  return (
    <CardInfoContainer>
      <h1>{title}</h1>
      <Box my={8} sx={{ display: { xs: 'block', md: 'none' } }}>
        {AddToCart}
      </Box>
      <section>
        <strong>Autor: </strong> {author}
      </section>
      <Box my={8} dangerouslySetInnerHTML={{ __html: description }}></Box>
      <Box my={8} sx={{ display: { xs: 'none', md: 'block' } }}>
        {AddToCart}
      </Box>
      <section>
        <Box mb={8}>
          <Typography component="h4" variant="subtitle1" color="textPrimary"><strong>Szczegóły kartki:</strong></Typography>
          <ul>
            <li>
              Format A4
            </li>
            <li >
              Możliwość dodania własnych życzeń
            </li>
            <li >
              Możliwość wyboru celu, na który przeznaczymy darowiznę
            </li>
          </ul>
        </Box>
        <Box>
          <Typography component="h4" variant="subtitle1" color="textPrimary"><strong>Dostępne opcje wysyłki:</strong></Typography>
          <CardSendingOptions>
            <li>
              <LinkIcon color="primary" />
              Wygenerowanie linka
            </li>
            <li >
              <PictureAsPdf color="primary" />
              Kartka w PDF
            </li>
          </CardSendingOptions>
        </Box>
      </section>
    </CardInfoContainer>
  );
};

export default CardInfo;
